<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    status: 'initial' | 'complete' | 'incomplete'
    index: number
    store: OwnbitConfigurator.Steps.Store
    isFirst?: boolean
    isLast?: boolean
    isCurrent?: boolean
    isBeforeCurrent?: boolean
    isAfterCurrent?: boolean
  }>(),
  {
    status: 'initial',
    isFirst: false,
    isLast: false,
    isCurrent: false,
    isBeforeCurrent: false,
    isAfterCurrent: false,
  },
)

const lifecycleStore = useLifecycleStore()

const colored = computed(() => props.isCurrent || props.isBeforeCurrent)
</script>

<template>
  <div
    class="flex h-full flex-col gap-1 px-6 py-4"
    :class="{
      rounded: isFirst && isLast,
      'rounded-t sm:rounded-l sm:rounded-tr-none': isFirst && !isLast,
      'rounded-b sm:rounded-r sm:rounded-bl-none': !isFirst && isLast,
      'bg-white text-black hover:bg-grey-50 active:bg-grey-100': !colored,
      'bg-green-700 text-white hover:bg-green-600 active:bg-green-800': colored,
      'border-r border-light-grey': !isLast,
    }"
  >
    <div class="flex items-center gap-2.5 font-copy text-s font-bold">
      <span>Schritt {{ index + 1 }}</span>
      <IconWarning
        v-if="lifecycleStore.attemptedSubmit && !store.isValid"
        class="pointer-events-none text-yellow-400"
      />
    </div>
    <div class="h5 m-0">
      <slot />
    </div>
    <div v-if="$slots.sublabel" class="font-copy text-s">
      <slot name="sublabel" />
    </div>
  </div>
</template>
